//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  data() {
    return {
      exportExcel: false,
      showPopup: false,
      visibleDoc: false,
      visibleDetail: false,
      includemask: false,
      LoadFirst: false,
      UserAccessData: {},
      wkS: "",
      wkE: "",
      weeks: [],
      vProcess: "",
      Processs: [],
      viewBy: "SO",
      vGroup: "ALL",
      Groups: [],
      GroupIn: "",
      vTeam: "ALL",
      // TeamMer: ['ALL', 'NAY1-1', 'NAY1-2', 'NAY1-3', 'TLA1-2', 'TLA2-1', 'TLA2-2', 'TLA3-1', 'TLA3-2'],
      Periods: [],
      TeamsKey: [],
      // Datas: [],
      QueryData: false,
      effsGrp: [],
      effsTeam: [],
      dataDetail: [],
      exportWKS: "",
      exportWKE: "",
      exportWKType: "FR Suggest Wk",
      exportTeam: "",
      exportDateS: "",
      exportDateE: "",
      initialPagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 0,
        // rowsNumber: xx if getting data from a server
      },
    };
  },
  async created() {
    this.TargetWK();
    let a = await this.getUserAccessData();
    // this.MasterGMT()

    setTimeout(() => this.LoadData(), 1000);
    // console.log('create')
  },
  async mounted() {},
  watch: {
    // whenever question changes, this function will run
    vProcess: function (newValue, oldValue) {
      if (newValue == "Document" || newValue == "Sample") {
        // this.Groups = this.UserAccessData.MerList
        this.vGroup = this.UserAccessData.MerList[0];
        this.GroupIn = this.UserAccessData.MerIn;
      }
      if (newValue == "FAB") {
        // this.Groups = this.UserAccessData.FABList
        this.vGroup = this.UserAccessData.FABList[0];
        this.GroupIn = this.UserAccessData.FABIn;
      }
      if (newValue == "Sew" || newValue == "Pack") {
        // this.Groups = ['ALL', 'G1', 'G2', 'G3', 'G4', 'GW', 'NYV1', 'TRM']
        // this.Groups = ['ALL']
        this.vGroup = "ALL";
        this.GroupIn = this.UserAccessData.SEWIn;
      }
      if (newValue == "FC") {
        // this.Groups = this.UserAccessData.QAList
        this.vGroup = this.UserAccessData.QAList[0];
        this.GroupIn = this.UserAccessData.QAIn;
      }
      if (newValue == "Pattern") {
        // this.Groups = this.UserAccessData.PatternList
        this.vGroup = this.UserAccessData.PatternList[0];
        this.GroupIn = this.UserAccessData.PatternIn;
      }

      this.LoadData();
    },
  },
  computed: {
    columnsGrp: function columns() {
      if (this.effsGrp.length == 0) {
        return [];
      }
      return Object.keys(this.effsGrp[0]);
    },
    columnsTeam: function columns() {
      if (this.effsTeam.length == 0) {
        return [];
      }
      return Object.keys(this.effsTeam[0]);
    },
  },
  methods: {
    getUserAccessData() {
      let params = new FormData();
      params.append("uid", this.$store.getters.uid);
      const obj = axios({
        method: "post",
        url: this.$api + "master.php/UserAccessData",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.UserAccessData = res.data;
        this.Processs = res.data.ProcessList;
        this.vProcess = res.data.ProcessList[0];
        // this.vProcess = "Sew";
        // console.log('1')
      });

      return obj;
    },
    MasterGMT() {
      let params = new FormData();
      axios({
        method: "post",
        url: this.$api + "master.php/master_gmt",
        data: params,
      }).then((res) => {
        this.gmts = res.data;
      });
    },
    create_UUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    OpenDialogExport(grpname) {
      this.exportExcel = true;
      this.exportTeam = grpname;
    },

    ExportExcelData: function () {
      if (this.exportWKS == "" || this.exportWKE == "") {
        this.$q.notify({
          position: "top-right",
          timeout: 2500,
          textColor: "white",
          color: "red",
          message: "Please fill Week!",
          html: true,
        });
        return false;
      } else {
        window.open(
          this.$apiflask +
            "export_otp/" +
            this.exportTeam +
            "/" +
            this.exportWKType +
            "/" +
            this.exportWKS +
            "/" +
            this.exportWKE +
            "?uuid=" +
            this.create_UUID(),
          "_export"
        );
      }
    },
    ExportExcelData2: function () {
      if (this.exportDateS == "" || this.exportDateE == "") {
        this.$q.notify({
          position: "top-right",
          timeout: 2500,
          textColor: "white",
          color: "red",
          message: "Please fill Date!",
          html: true,
        });
        return false;
      } else {
        window.open(
          this.$apiflask +
            "export_otp2/" +
            this.exportTeam +
            "/" +
            this.exportDateS +
            "/" +
            this.exportDateE +
            "?uuid=" +
            this.create_UUID(),
          "_export"
        );
      }
    },

    TargetWK() {
      let params = new FormData();

      const obj = axios({
        method: "post",
        url: this.$api + "master.php/targetWk",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.weeks = res.data.Weeks;
        this.wkS = res.data.wkS;
        this.wkE = res.data.wkE;
        this.exportWKS = res.data.wkS;
        this.exportWKE = res.data.wkE;
        // console.log('2')
      });

      return obj;
    },
    async LoadData() {
      // console.log(this.vProcess)
      // console.log(this.GroupIn)
      if (this.vProcess == "Document") {
        this.LoadDataDoc();
      } else if (this.vProcess == "Sample") {
        this.LoadDataSam();
      } else if (this.vProcess == "FAB") {
        this.LoadDataFab();
      } else if (this.vProcess == "Sew") {
        this.LoadDataSew();
      } else if (this.vProcess == "Pack") {
        this.LoadDataPack();
      } else if (this.vProcess == "FC") {
        this.LoadDataFC();
      } else if (this.vProcess == "Pattern") {
        this.LoadDataPattern();
      }
    },

    async LoadDataDoc() {
      // console.log(this.GroupIn)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        url: this.$apiflask + "eff_doc_group",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        url: this.$apiflask + "eff_doc_team",
        data: params,
      }).then((res) => {
        // console.log(res.data);
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    async LoadDataSam() {
      // console.log(this.GroupIn)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        url: this.$apiflask + "eff_sam_group",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        url: this.$apiflask + "eff_sam_team",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    async LoadDataFab() {
      // console.log(this.GroupIn)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        // url: this.$apiflask + 'eff_fab_group',
        url: `${this.$apiflask}eff_fab_group_2021`,
        data: params,
      }).then((res) => {
        // console.log(res.data);
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        // url: this.$apiflask + 'eff_fab_team',
        url: `${this.$apiflask}eff_fab_team_2021`,
        data: params,
      }).then((res) => {
        // console.log(res.data);
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    async LoadDataSew() {
      // console.log(this.UserAccessData)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        url: this.$apiflask + "eff_sew_group_2021",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        url: this.$apiflask + "eff_sew_team_2021",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    async LoadDataPack() {
      // console.log(this.UserAccessData)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        url: this.$apiflask + "eff_pack_group_2021",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        url: this.$apiflask + "eff_pack_team_2021",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    async LoadDataFC() {
      // console.log(this.UserAccessData)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        url: this.$apiflask + "eff_fc_group",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        url: this.$apiflask + "eff_fc_team",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    async LoadDataPattern() {
      // console.log(this.UserAccessData)
      this.visibleDoc = true;
      let params = new FormData();

      params.append("ws", this.wkS);
      params.append("we", this.wkE);
      params.append("mask", this.includemask);
      params.append("viewby", this.viewBy);
      params.append("filter_group", this.vGroup);
      params.append("groupin", this.GroupIn);

      await axios({
        method: "post",
        url: this.$apiflask + "eff_pattern_group",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsGrp = res.data;
      });

      await axios({
        method: "post",
        url: this.$apiflask + "eff_pattern_team",
        data: params,
      }).then((res) => {
        // console.log(res.data)
        this.effsTeam = res.data;
        this.visibleDoc = false;
      });
    },

    CellClass(val) {
      if (val == null) {
        return "background-color:silver;cursor:pointer;";
      } else if (val == 0) {
        return "background-color:#ffffff;cursor:pointer;";
      } else if (val < 10) {
        return "background-color:#eaf4ea;cursor:pointer;";
      } else if (val < 20) {
        return "background-color:#d5ead5;cursor:pointer;";
      } else if (val < 30) {
        return "background-color:#c0e0c0;cursor:pointer;";
      } else if (val < 40) {
        return "background-color:#abd5ab;cursor:pointer;";
      } else if (val < 50) {
        return "background-color:#97cb97;cursor:pointer;";
      } else if (val < 60) {
        return "background-color:#82c182;cursor:pointer;";
      } else if (val < 70) {
        return "background-color:#6db66d;cursor:pointer;";
      } else if (val < 80) {
        return "background-color:#58ac58;cursor:pointer;";
      } else if (val < 90) {
        return "background-color:#43a243;cursor:pointer;";
      } else if (val >= 90) {
        return "background-color:#2f982f;cursor:pointer;";
      }
    },

    ShowDetailGroup(row, col) {
      // console.log(this.vProcess);
      // console.log(row, col);
      let grp = row["GROUP-NAME"];
      let loc = "ALL";
      let period = col.substring(1);

      let urlProcess = "";
      if (this.vProcess == "Document") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_doc_grp/${grp}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "Sample") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_sample_grp/${grp}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "FAB") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_fabric/${grp}/${loc}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "Sew") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_sew/${grp}/${loc}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "Pack") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_pack/${grp}/${loc}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "FC") {
        urlProcess = "fc_grp";
      } else if (this.vProcess == "Pattern") {
        urlProcess = "pattern_grp";
      }

      // this.visibleDetail = true;
      // this.showPopup = true;

      // let params = new FormData();

      // params.append("wk", col);
      // params.append("grp", row["GROUP-NAME"]);

      // axios({
      //   method: "post",
      //   url: this.$api + "otpdetail2021.php/" + urlProcess,
      //   data: params,
      // }).then((res) => {
      //   // console.log(res.data);
      //   this.dataDetail = res.data;
      //   this.visibleDetail = false;
      // });
    },

    ShowDetailTeam(row, col) {
      // console.log(row['TEAM-NAME'])
      let team = row["GROUP-NAME"];
      let array = row["GROUP-NAME"].split("-");
      let grp = "";
      let loc = "";
      let period = col.substring(1);
      if (array.length == 2) {
        grp = array[0];
        loc = array[1];
      } else {
        grp = array[0] + "-" + array[1];
        loc = array[2];
      }


      let urlProcess = "";
      if (this.vProcess == "Document") {
         window.open(
          `${
            this.$apiflask
          }otpdetail_doc_team/${team}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "Sample") {
         window.open(
          `${
            this.$apiflask
          }otpdetail_sample_team/${team}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "FAB") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_fabric/${grp}/${loc}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "Sew") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_sew/${grp}/${loc}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "Pack") {
        window.open(
          `${
            this.$apiflask
          }otpdetail_pack/${grp}/${loc}/${period}/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.vProcess == "FC") {
        urlProcess = "fc_grp";
      } else if (this.vProcess == "Pattern") {
        urlProcess = "pattern_grp";
      }

      // let period = col.substring(1);

      // let urlProcess = "";
      // if (this.vProcess == "Document") {
      //   urlProcess = "doc_team";
      // } else if (this.vProcess == "Sample") {
      //   urlProcess = "sam_team";
      // } else if (this.vProcess == "FAB") {
      //   urlProcess = "fab_team";
      // } else if (this.vProcess == "Sew") {
      //   urlProcess = "sew_team";
      // } else if (this.vProcess == "Pack") {
      //   urlProcess = "pack_team";
      // } else if (this.vProcess == "FC") {
      //   urlProcess = "fc_team";
      // } else if (this.vProcess == "Pattern") {
      //   urlProcess = "pattern_team";
      // }

      // this.visibleDetail = true;
      // this.showPopup = true;

      // let params = new FormData();

      // params.append("wk", col);
      // params.append("team", row["GROUP-NAME"]);

      // axios({
      //   method: "post",
      //   url: this.$api + "otpdetail2021.php/" + urlProcess,
      //   data: params,
      // }).then((res) => {
      //   // console.log(res.data);
      //   this.dataDetail = res.data;
      //   this.visibleDetail = false;
      // });
    },
  },
};
